/* angular:styles/component:scss;724b3a570f189ddf7001b01ef95c00ca8946aed922e09b05de4cd5bda3d2868b;D:\Techriff-Project\3amautocare\Autocare.Api\ClientApp\src\app\module\users\types\formly-field-date-range-min.component.ts */
::ng-deep .p-inputgroup-addon {
  background: #fff !important;
}
.formly-validation-message {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}
/*# sourceMappingURL=formly-field-date-range-min.component-R2A2LZIQ.css.map */
